export default "__VITE_ASSET__Cgi4EWoL__"